import './styles.scss';
import { Route, Routes } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import ProductoresYSalas from './pages/ProductoresYSalas';
import { connect } from 'react-redux';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Eventos from './pages/Eventos';
import EventoSeleccionado from './pages/EventoSeleccionado';
import PagoFinalizado from './pages/PagoFinalizado';
import CompraRevalidarMercadoPago from './pages/CompraRevalidarMercadoPago';
import ErrorHandler from './components/ErrorHandler';
import Health from './pages/Health';
import CookiePolicy from "./components/cookiePolicy";
import CompraRevalidarRedSys from './pages/CompraRevalidarRedSys';
import LandingRecinto from './pages/LandingRecinto';
import VenderEntradas from './pages/VenderEntradas';
import EventosPopulares from './pages/EventosPopulares';
import SmartTicketConfirmaTransferencia from './pages/SmartTicketConfirmaTransferencia';
import TerminarCompraVendedor from './pages/TerminarCompraVendedor';
import SmartTicket from './pages/SmartTicket';
import DeudaSeleccionada from './pages/DeudaSeleccionada';
import PagoValidar from './pages/PagoValidar';
import EventosImportantes from './pages/EventosImportantes';
import CompraRevalidarMODO from './pages/CompraRevalidarMODO';
import ArticleDiscovery from './pages/ArticleDiscovery';
import FolckPromoAmigo from './pages/FolckPromoAmigo';
import BotonArrepentimiento from './pages/BotonArrepentimiento';
import ComunidadesEntradaweb from './pages/ComunidadesEntradaweb';
import StaticHome from './pages/StaticHome';
import { homePath, withStaticHome } from '../api/staticHome';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FF6600',
    },
    secondary: {
      main: '#ffffff',
    },
  },
});


function App() {

  return (
    <>
    <div className="App App_mobile">
      <ThemeProvider theme={theme}>
        <Header />
        <div className='main-wrapper'>
          <Routes>
            {withStaticHome && <Route path='/' element={<StaticHome />} />}
            <Route path={homePath} element={<Home />} />
            <Route path="/actuator/health/readiness" element={<Health />}/>
            <Route path='/productores-y-salas' element={<ProductoresYSalas />} />
            <Route path='/eventos' element={<Eventos />} />
            <Route path='/evento/:hashEvent/step/:pasoCompra' element={<EventoSeleccionado />} />
            <Route path='/pago-finalizado/:checkoutType/:additionalCode?' element={<PagoFinalizado />} />
            <Route path='/pago-pendiente/:checkoutType/:paymentMethod?/:additionalCode?/:eventType?' element={<PagoFinalizado />} />
            <Route path='/compra-revalidar-mercadopago' element={<CompraRevalidarMercadoPago />} />
            <Route path='/compra-revalidar-redsys' element={<CompraRevalidarRedSys />} />
            <Route path='/compra-revalidar-modo' element={<CompraRevalidarMODO />} />
            <Route path='/vender-entradas' element={<VenderEntradas />} />
            <Route path='/pagos/:hashEvent/step/:pasoCompra' element={<DeudaSeleccionada />} />
            <Route path='/pago' element={<PagoValidar />} />
            <Route path='/25-eventos-importantes-en-espana-2025' element={<EventosImportantes />} />
            <Route path='/los-30-eventos-mas-populares' element={<EventosPopulares />} />
            <Route path='/confirmar-transferencia' element={<SmartTicketConfirmaTransferencia />} />
            <Route path='//festivales-mendoza-2026-entradas-web' element={<ArticleDiscovery />} />
            <Route path='/vendimia-2026' element={<BotonArrepentimiento />} />
            <Route path='/terminar-pago' element={<TerminarCompraVendedor />} />
            <Route path='/smart-ticket' element={<SmartTicket />} />
            <Route path='/comunidades' element={<ComunidadesEntradaweb />} />
            <Route path='/:landing' element={<LandingRecinto />} />
          </Routes>
        </div>
        <ErrorHandler />
        <CookiePolicy />
        <Footer />
      </ThemeProvider>
    </div>
    </>
  );
}


export default connect()(App);
